import { CONSTANTS } from 'src/app/config/constants';
import { IUser } from 'src/app/interface/user';
import * as moment from 'moment-timezone';
import { StringHelper } from '../string/string-helper';
import { LocalStorage } from 'src/app/class/local-storage';
import { TypeOf } from 'src/app/enum/type-of';

export class DateTime {
	public static local(value?: any): moment.Moment {
		const user = LocalStorage.get(CONSTANTS.localStorage.keys.user) as IUser;
		const timezone = 'UTC';
		if (!value) {
			return moment.utc().tz(user?.timezone ? user.timezone : timezone);
		}
		return moment.utc(value).tz(user?.timezone ? user.timezone : timezone);
	}

	public static format(value: any, format?: string): string {
		if (!format) {
			format = 'MMM D, LT';
		}
		return DateTime.local(value).format(format);
	}

	public static isValid(value: any): boolean {
		return moment(value).isValid();
	}

	public static duration(start: any, end?: any): moment.Duration {
		if (typeof start === TypeOf.STRING && DateTime.isValid(start)) {
			start = moment.utc(start);
		};
		if (typeof end === TypeOf.STRING && DateTime.isValid(end)) {
			end = moment.utc(end);
		};
		if (!end) {
			end = moment();
		}
		return moment.duration(end.diff(start));
	}

	public static printDuration(duration: moment.Duration): string {
		let milliseconds = duration.asMilliseconds();
		milliseconds = milliseconds >= 0 ? milliseconds : 0;
		const totalSeconds = Math.floor(milliseconds / 1000);
		const totalMinutes = Math.floor(totalSeconds / 60);
		const totalHours = Math.floor(totalMinutes / 60);
		const days = Math.floor(totalHours / 24);
		const seconds = Math.floor(totalSeconds % 60);
		const minutes = Math.floor(totalMinutes % 60);
		const hours = Math.floor(totalHours % 24);
		let result = StringHelper.sprintf(
			'%s:%s:%s',
			StringHelper.padLeft(hours, 2),
			StringHelper.padLeft(minutes, 2),
			StringHelper.padLeft(seconds, 2)
		);
		if (days) {
			result = StringHelper.sprintf(
				'%sD %s',
				days,
				result
			);
		}
		return result;
	}
}
